import { Tabs, TabList, TabPanels, TabPanel } from '@chakra-ui/react';
import { IoDocumentOutline, IoReaderOutline, IoStarOutline } from 'react-icons/io5';
import TabNameDisplayed from './TabNameDisplayed';
import TableStructure from './TableStructure';
import SubscriptionTab from './SubscriptionTab';
import { Box } from '@chakra-ui/react';
import InvoicesToPayContext from '../contexts/InvoicesToPayContext';
import SubscriptionsContext from '../contexts/SubscriptionsContext';
import StepperContext from '../contexts/StepperContext';
import TabContext from '../contexts/TabContext';

import { INVOICE_TABS, InvoiceTab } from '../constants/enums';
import { useContext, useEffect, useMemo } from 'react';

type Props = { rightContent?: React.ReactNode };

const TabContainer = ({ rightContent }: Props): JSX.Element => {
  const { tabSelected, setTabSelected } = useContext(TabContext);
  const { hasActiveSubscription, isEnabled } = useContext(SubscriptionsContext);

  const showPalommaPlusTab = hasActiveSubscription || isEnabled;

  const tabsInformation = useMemo(
    () => [
      { index: 0, text: INVOICE_TABS.PENDING as InvoiceTab, IconComponent: IoDocumentOutline },
      { index: 1, text: INVOICE_TABS.PAID as InvoiceTab, IconComponent: IoReaderOutline },
      ...(showPalommaPlusTab
        ? [{ index: 2, text: INVOICE_TABS.PALOMMA_PLUS as InvoiceTab, IconComponent: IoStarOutline }]
        : []),
    ],
    [showPalommaPlusTab]
  );

  const getTabIndex = (tab: InvoiceTab) => {
    return tabsInformation.find((ele) => ele.text === tab)?.index;
  };

  const { invoicesToPay } = useContext(InvoicesToPayContext);
  const { resetStepper, activeStepContext } = useContext(StepperContext);
  const { activeStep } = activeStepContext;

  useEffect(() => {
    if (tabSelected === INVOICE_TABS.PENDING) {
      if (invoicesToPay.length < 1) return resetStepper(-1);
      if (activeStep > 0) return;
      if (invoicesToPay.length) resetStepper(0);
    }
  }, [invoicesToPay.length, resetStepper, tabSelected, activeStep]);
  return (
    <Tabs
      index={getTabIndex(tabSelected)}
      onChange={(index) => setTabSelected(tabsInformation[index].text)}
      width={'100%'}
    >
      <TabList overflowX="auto" overflowY="hidden" flexWrap="nowrap">
        {tabsInformation.map((ele, index) => (
          <TabNameDisplayed
            IconComponent={ele.IconComponent}
            text={ele.text}
            color={getTabIndex(tabSelected) !== ele.index ? '#9F9DB0' : undefined}
            key={index}
            onClick={() => {
              setTabSelected(ele.text);
            }}
          />
        ))}
      </TabList>
      <TabPanels>
        {tabsInformation.map((ele, index) => (
          <TabPanel key={index} display={'flex'} gap={'24px'} width={'100%'} alignItems={'flex-start'} px={0}>
            {getTabIndex(tabSelected) === ele.index &&
              (ele.text === INVOICE_TABS.PALOMMA_PLUS ? <SubscriptionTab /> : <TableStructure tab={ele.text} />)}
            {rightContent && (
              <Box width={'50%'} maxWidth={'450px'}>
                {rightContent}
              </Box>
            )}
          </TabPanel>
        ))}
      </TabPanels>
    </Tabs>
  );
};

export default TabContainer;
